"use client";

import { useEffect, useState } from "react";
import { usePathname } from "next/navigation";
import { ChevronUp, MoveUp } from "lucide-react";
import { colorPalette } from "@/utils/theme";

export default function ScrollToTop() {
  const pathname = usePathname();
  const [showBtn, setShowBtn] = useState(false);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  }, [pathname]);

  useEffect(() => {
    const handleScroll = () => {
      setShowBtn(window.scrollY > 200);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const handleScrollTop = () => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <>
      {showBtn && (
        <button
          onClick={handleScrollTop}
          style={{ backgroundColor: colorPalette.primary[500] }}
          className=" group fixed bottom-3 right-6 sm:right-3  w-8 h-8 sm:w-12 sm:h-12  rounded-full text-white  flex items-center justify-center  shadow-lg transition-all duration-300  ] z-50 cursor-pointer overflow-hidden border-[2px] border-white"
        >
          <span className=" absolute inset-0 flex items-center justify-center opacity-100 group-hover:opacity-0 transition-opacity duration-200">
            <MoveUp size={22} className="sm:w-6 sm:h-6 w-4 h-4" />
          </span>

          <span className=" absolute inset-0 flex flex-col items-center justify-center  opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-[6px] sm:text-[10px] font-semibold leading-tight">
            BACK <br /> TO TOP
          </span>
        </button>
      )}
    </>
  );
}
